import { Layout } from "antd";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import HomePageAgencySection from "../../../components/HomePageAgencySection/HomePageAgencySection";
import HomePageAnimatedSection from "../../../components/HomePageAnimatedSection/HomePageAnimatedSection";
import HomePageCreatorSection from "../../../components/HomePageCreatorSection/HomePageCreatorSection";
import HomePageFooter from "../../../components/HomePageFooter/HomePageFooter";
import HomePageHeroSection from "../../../components/HomePageHeroSection/HomePageHeroSection";
import HomePageNavbarComponent from "../../../components/HomePageNavbarComponent/HomePageNavbarComponent";
import HomePageQuestionSection from "../../../components/HomePageQuestionSection/HomePageQuestionSection";
import HomePageSecuritySection from "../../../components/HomePageSecuritySection/HomePageSecuritySection";
import useHomePageInfos from "../../../hooks/global/useHomePageInfos";
import { APP_DOMAIN } from "../../../utls/constants";
import languageUtil from "../../../utls/LanguageUtil";
import "./index.less";

const HomePage = () => {
  const { t } = useTranslation();
  useHomePageInfos(t);

  return (
    <Layout className="HomePageWrapper">
      <Helmet>
        <html lang={languageUtil.getPublicCurrentLanguage()} />
        <title>{t("homepage.meta.title") as string}</title>
        <meta name="description" content={t("homepage.meta.description") as string} />

        <meta property="og:type" content="website" />
        <meta property="og:title" content={t("homepage.meta.title") as string} />
        <meta property="og:description" content={t("homepage.meta.description") as string} />
        <meta property="og:locale" content={languageUtil.getPublicCurrentLanguage()} />
        <meta property="og:site_name" content={(t("homepage.meta.siteName") as string) || "Twizz"} />

        <link rel="alternate" href={window.location.href} hrefLang="x-default" />
        <link rel="alternate" href={window.location.href} hrefLang="fr" />
        <link rel="alternate" href={window.location.href} hrefLang="en" />
        <link rel="alternate" href={window.location.href} hrefLang="es" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: (t("homepage.meta.siteName") as string) || "Twizz",
            url: `https://www.${APP_DOMAIN}`,
            logo: `https://www.${APP_DOMAIN}/logo.png`,
          })}
        </script>
      </Helmet>
      <HomePageNavbarComponent />
      <HomePageHeroSection />
      <HomePageAnimatedSection />
      <HomePageAgencySection />
      <HomePageSecuritySection />
      <HomePageCreatorSection />
      <HomePageQuestionSection />
      <HomePageFooter />
    </Layout>
  );
};

export default HomePage;
